import {useEffect} from "react";
import {useFormContext} from "react-hook-form";

import {InputField} from "@/components/form/fields/InputField/InputField.tsx";
import {ServerErrors} from "@/lib/types/common.ts";
import {IntegrationFormData} from "@/lib/types/integrations.ts";
import {SetupInfo} from "@/pages/integrations/edit/subForms/components/SetupInfo.tsx";
import {IntegrationModuleInfo, IntegrationModules} from "@/pages/integrations/integrations.types.ts";

export type FormValuesKey = keyof IntegrationFormData;

interface GeckoBoardFormProps {
  serverErrors?: ServerErrors;
}

export const GeckoBoardForm = ({serverErrors}: GeckoBoardFormProps) => {
  const {setError} = useFormContext();

  useEffect(() => {
    if (serverErrors) {
      Object.keys(serverErrors)
        .filter((k) => k !== "__all__")
        .forEach((key) => setError(`settings.${key}` as FormValuesKey, {message: serverErrors[key][0]}));
    }
  }, [setError, serverErrors]);

  return (
    <>
      <div className="row row-cols-2 mb-3">
        <div className="col-6 mb-3">
          <InputField name="settings.api_key" label="API Key" required={true} maxLength={32} autoFocus={true} />
        </div>
        <div className="col-6 mb-3">
          <InputField name="settings.dataset_name" label="Dataset Name" required={true} maxLength={64} />
        </div>
      </div>
      <SetupInfo>
        <div className="p-2">
          Login to the Geckoboard Dashboard and click on your initials in the top right-hand side, then{" "}
          <strong>Account</strong>. Scroll down to find and copy the <strong>API Key</strong>. Return to your Dashboard
          and click the <strong>Add Widget</strong> button. Select <strong>Datasets</strong> as the source, and then
          return to Uptime.com.
        </div>
        <div className="p-2">
          Paste the <strong>API Key</strong> into the field as shown below, then provide a <strong>Dataset Name</strong>
          .
        </div>
        <div className="p-2">
          <a target="_blank" href="https://support.uptime.com/hc/en-us/articles/115002536589-Configuring-Geckoboard">
            View {IntegrationModuleInfo[IntegrationModules.GECKOBOARD].label} Support Article &rarr;
          </a>
        </div>
      </SetupInfo>
    </>
  );
};
